import React from 'react';
import PropTypes from 'prop-types';
import {
  Container, Row, Col, Form, InputGroup,
} from 'react-bootstrap5';

export default function Filters({ setKeyword, checkCategory, categories }) {
  return (
    <Container fluid>
      <Row className="mb-4">
        <Col md={12}>
          <InputGroup>
            <InputGroup.Text>
              <div className="icon-with-text">
                <i className="search-icon small-icon" />
              </div>
            </InputGroup.Text>
            <Form.Control
              placeholder="Search"
              className="border-start-0"
              onChange={(e) => setKeyword(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
      <div className="mb-4 resource-filters">
        {categories.map((item) => (
          <Form.Check
            key={item}
            type="checkbox"
            inline
            name="type_resource"
            id={`type_resource_${item}`}
            label={item}
            className="form-check-buttons"
            defaultChecked={false}
            onClick={() => {
              checkCategory(item);
            }}
          />
        ))}
      </div>
    </Container>
  );
}

Filters.propTypes = {
  setKeyword: PropTypes.func.isRequired,
  checkCategory: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
};
